import { render, staticRenderFns } from "./FlowProps.vue?vue&type=template&id=2b3bf083&scoped=true"
import script from "./FlowProps.vue?vue&type=script&lang=js"
export * from "./FlowProps.vue?vue&type=script&lang=js"
import style0 from "./FlowProps.vue?vue&type=style&index=0&id=2b3bf083&prod&lang=css"
import style1 from "./FlowProps.vue?vue&type=style&index=1&id=2b3bf083&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b3bf083",
  null
  
)

export default component.exports